import { useTranslation } from 'react-i18next';
import { Input } from '@salecycle/ui-component-library';
import { useWorkflowForm } from '../../../../contexts/CampaignWorkflowFormContext';
import { ConfigurationOption } from '../../components/ConfigurationOption';
import { InfoTooltip } from 'sections/onsite-campaigns/pages/CampaignEditor/components/InfoTooltip';

export type InactivityConfigurationProps = {
  value?: number;
  onChange: (value: number) => void;
};

export function InactivityConfiguration({ value, onChange }: InactivityConfigurationProps) {
  const { t } = useTranslation('campaigns');
  const { formDisabled } = useWorkflowForm();

  return (
    <ConfigurationOption>
      <Input
        tooltipComponent={
          <InfoTooltip
            title={t('onsite.campaignInactivityDuration.tooltipTitle')}
            content={t('onsite.campaignInactivityDuration.tooltipContent')}
            displayInline
          />
        }
        disabled={formDisabled}
        type="number"
        min="0"
        label={t('onsite.campaignInactivityDuration.label')}
        ariaLabel={t('onsite.campaignInactivityDuration.label')}
        placeholder={t('onsite.campaignInactivityDuration.placeholder')}
        validationState={value && 'complete'}
        value={value || ''}
        onChange={(newValue: string) => onChange(parseInt(newValue))}
      />
    </ConfigurationOption>
  );
}
